// Shared cart helpers — real Shopify AJAX Cart API (replaces the mockup's localStorage cart.js)

function rushUpdateCartCount() {
  fetch(window.rushRoutes.cartJsonUrl)
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    });
}

function rushAddToCart(variantId, quantity, properties) {
  var body = { id: variantId, quantity: quantity };
  if (properties) body.properties = properties;
  return fetch(window.rushRoutes.cartAddUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  }).then(function (r) {
    if (!r.ok) return r.json().then(function (e) { throw e; });
    return r.json();
  }).then(function (result) {
    rushUpdateCartCount();
    return result;
  });
}

function rushUpdateCartLine(id, quantity, sections) {
  var body = { id: id, quantity: quantity };
  if (sections) body.sections = sections;
  return fetch(window.rushRoutes.cartChangeUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  }).then(function (r) { return r.json(); })
    .then(function (result) {
      rushUpdateCartCount();
      return result;
    });
}

document.addEventListener('DOMContentLoaded', rushUpdateCartCount);
